module.exports = __webpack_public_path__ + "img/live_ship.0fa83df7.png";